// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3WjEj","title":"Images45_title__3Ivqo","images":"Images45_images__3aIW0"};